import { COVERGO_SAAS_DEV } from "../consts.js"

export const simplyhealth = {
	"simplyhealth-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "simplyhealth_dev",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_DEV,
	}
}
